import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Supplier } from "@models/supplier";
import { deleteRequest, fetchRequest } from "@actions/supplier";
import SupplierTable from "@components/supplier/Table";
import { Button, Card} from "antd";
import TableRenderer from "@hocs/TableRenderer";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import SearchSupplierComponent from "../../components/supplier/Search";

interface PropsFromState {
  loading: boolean;
  data: Supplier[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class SupplierIndexPage extends React.Component<AllProps> {
  deleteSupplier = (item: Supplier): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/suppliers/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_supplier"
                defaultMessage={`Create Supplier`}
              />
            </Button>
          </NavLink>
        </div>

        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchSupplierComponent search={search} />
          </Card>

          <SupplierTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteSupplier}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ supplier }: ApplicationState) => ({
  loading: supplier.loading,
  errors: supplier.errors,
  data: supplier.data,
  count: supplier.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(SupplierIndexPage));
